"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csLocaleData = require("i18next-icu/locale-data/cs");
exports.default = csLocaleData;
//# sourceMappingURL=cs.js.map